var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLandingImageSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1376_15641",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 60,
    height: 60
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.63199,
    y: 8.56934,
    width: 58.736,
    height: 58.736,
    fill: "url(#pattern0)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1376_15641)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8.63199,
    y: 7.23438,
    width: 58.736,
    height: 58.736,
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1376_15641",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1376_15641",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,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"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandingImageSearch);
export default __webpack_public_path__ + "static/media/landingImageSearch.e7ebb39d6c9e361be8c6f798e10e090d.svg";
export { ForwardRef as ReactComponent };